/**
 * Rota `/ctos` — Fase 2 PR-D do TD26 roadmap.
 *
 * Lista de CTOs (Caixas Terminais Opticais = splitters no jargão Voalle).
 * Source: `/api/v2/topology?type=splitter` via `useTopologyQuery`.
 *
 * Pra primeira versão:
 * - Lista virtualizada (suporta 500+ CTOs)
 * - Search local por code/description
 * - Sem mapa (cockpit já mostra; CTO no mapa entra como toggle layer em PR
 *   futura)
 *
 * Click numa CTO ainda não tem destino (sem CTO drawer/page ainda).
 * Por ora só lista informativa.
 */

import { CtoHeader } from '@/features/topology/CtoHeader';
import { CtoList } from '@/features/topology/CtoList';
import { useTopologyQuery } from '@/features/topology/useTopologyQuery';
import { createFileRoute } from '@tanstack/react-router';
import { useMemo, useState } from 'react';

export const Route = createFileRoute('/_auth/ctos')({
  component: CtosPage,
});

function CtosPage() {
  const { data, isPending, isError } = useTopologyQuery({ type: 'splitter' });
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    if (!data) return [];
    const q = search.trim().toLowerCase();
    if (!q) return data;
    return data.filter(
      (p) =>
        (p.code?.toLowerCase().includes(q) ?? false) ||
        (p.description?.toLowerCase().includes(q) ?? false),
    );
  }, [data, search]);

  if (isPending) {
    return (
      <div className="flex h-full w-full items-center justify-center p-8 text-sm text-fg-subtle">
        Carregando CTOs…
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex h-full w-full flex-col items-center justify-center gap-2 p-8 text-sm">
        <p className="text-status-critical">Falha ao carregar CTOs.</p>
        <p className="text-fg-subtle">Reload da página tenta novamente.</p>
      </div>
    );
  }

  return (
    <div className="flex h-full w-full flex-col overflow-hidden">
      <CtoHeader
        total={data?.length ?? 0}
        filtered={filtered.length}
        search={search}
        onSearchChange={setSearch}
      />
      <div className="flex-1 overflow-hidden px-6 pb-6">
        <CtoList items={filtered} />
      </div>
    </div>
  );
}
